import {Icon} from '@wandb/weave/components/Icon';
import React, {useCallback} from 'react';

import {Banner} from '../../../../Banner';
import {MAX_RUNS_PERF_WARNING_THRESHOLD} from '../../../../PanelMediaBrowser/config';
import {
  DEFAULT_LINE_PLOT_NUM_RUNS_NEW,
  DEFAULT_PANEL_MAX_NUM_RUNS,
} from '../../runLinePlots/maxRunDefaults';
import {SettingsSliderInput} from '../common/SettingsSliderInput';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const MaxRuns = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  const initialValue = config.maxRuns ?? DEFAULT_LINE_PLOT_NUM_RUNS_NEW;

  // Debounce the updateConfig call so we don't update on every keystroke or slider change
  const updateConfigCallback = useCallback(
    (value: number) => {
      updateConfig({maxRuns: value});
    },
    [updateConfig]
  );

  return (
    <div className="flex flex-col">
      <SettingTitle
        title="Max runs to include"
        id="max-runs-label"
        configField="maxRuns"
        unsetConfigField={() => unsetConfigField('maxRuns')}
      />
      <SettingsSliderInput
        initialValue={initialValue}
        updateConfigCallback={updateConfigCallback}
        max={DEFAULT_PANEL_MAX_NUM_RUNS}
        data-test="max-runs-slider-input"
        aria-labelledby="max-runs-label"
      />
      {initialValue >= MAX_RUNS_PERF_WARNING_THRESHOLD && (
        <Banner
          className="my-12 flex items-start justify-start gap-8 p-12 text-sm"
          variant="warning">
          <div className="flex items-center">
            <Icon name="warning" className="mt-1 h-18 w-18 shrink-0" />
            <p className="pl-12">
              Including a large number of runs may affect performance and
              usability.
            </p>
          </div>
        </Banner>
      )}
    </div>
  );
};
